import { render, staticRenderFns } from "./TopicThread.vue?vue&type=template&id=4d971106&scoped=true&"
import script from "./TopicThread.vue?vue&type=script&lang=js&"
export * from "./TopicThread.vue?vue&type=script&lang=js&"
import style0 from "../FeedContent/FeedContent.scss?vue&type=style&index=0&id=4d971106&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d971106",
  null
  
)

export default component.exports